import abstract from './abstract'
import Video from './video'

import VideoGroup from '@/sections/video-group'

export default class extends abstract {
  getComponent () {
    return VideoGroup
  }

  get videos () {
    return this.item.properties.videoGroup.map(video => new Video(video))
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/video-group.js